export default __webpack_public_path__ + "static/rear-3ead2676e0324469fddcb3bc1b6fcefe.jpg";